import { render, staticRenderFns } from "./PappersChiefs.vue?vue&type=template&id=24a99560&scoped=true"
import script from "./PappersChiefs.vue?vue&type=script&lang=js"
export * from "./PappersChiefs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a99560",
  null
  
)

export default component.exports